<div class="div-27 mb-3">{{reportPlaceHolders['LBL_REPORT_CUSTOM_4']}}</div>
<p>{{reportPlaceHolders['LBL_REPORT_CUSTOM_5']}}</p>


<div class="merchant-details-card">
  <div class="merchant-logo-container">
    <img *ngIf="brandlogo" [src]="brandlogo" alt="Merchant Logo" class="merchant-logo" />
  </div>
  <div class="merchant-info">
    <h2 class="merchant-title">{{ userData.marketplace_name }}</h2>
    <p class="merchant-address">
      <i class="fas fa-map-marker-alt"></i>
      {{reportPlaceHolders['LBL_ADDRESS']}}: {{ userData.addressLine1 }}, {{ userData.city_name }}, {{
      userData.country_name }}
    </p>
    <p class="merchant-contact">
      <i class="fas fa-phone-alt"></i>
      Business Contact: +{{userData.phone_country_code}}{{ userData.business_contact_number }}
    </p>
    <p class="merchant-available">
      <i class="fas fa-clock"></i>
      {{reportPlaceHolders['LBL_AVAILABLE_FROM']}}: {{ merchantDate }}
    </p>
  </div>
  <button class="export-btn me-2" (click)="GetAllPdfData()">{{reportPlaceHolders['LBL_lower_Deals_Claimed']}}</button>
  <!-- <button class="export-btn" (click)="goBack()">{{reportPlaceHolders['LBL_lower_Favourites']}}</button> -->
</div>

<div class="summary-container">
  <span><strong>{{reportPlaceHolders['LBL_TOTAL_DEALS']}}:</strong> {{ reportTotalDeals }}</span>
  <span><strong>{{reportPlaceHolders['LBL_TOTAL_BUDGET']}}:</strong> {{ reportTotalBudget }}</span>
  <span><strong>{{reportPlaceHolders['LBL_TOTAL_SPENT']}}:</strong> {{ reportTotalSpent }}</span>
  <span><strong>{{reportPlaceHolders['LBL_TOTAL_CHARGED']}}:</strong> {{ reportSpendCharged }}</span>
</div>
<hr />
<div class="row mb-4">
  <!-- Active Deals -->
  <div class="col-md-3 mb-3">
    <div class="card text-white h-100" style="background-color: #2F4050;">
      <div class="card-body d-flex flex-column justify-content-between">
        <h6 class="card-title">ACTIVE DEALS <small>(as of now)</small></h6>
        <h4>{{eventsData?.activeDealsCount}}</h4>
        <div class="text-end">
          <div class="flex-shrink-0">
            <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="3em" height="3em"
                                class="text-muted " fill="white">
                                <path
                                    d="M19.0001 14V17H22.0001V19H18.9991L19.0001 22H17.0001L16.9991 19H14.0001V17H17.0001V14H19.0001ZM20.2426 4.75748C22.505 7.02453 22.5829 10.6361 20.4795 12.9921L19.06 11.5741C20.3901 10.05 20.3201 7.66 18.827 6.17022C17.3244 4.67104 14.9076 4.60713 13.337 6.017L12.0019 7.21536L10.6661 6.01793C9.09098 4.60609 6.67506 4.66821 5.17157 6.1717C3.68183 7.66143 3.60704 10.0474 4.97993 11.6233L13.412 20.0691L11.9999 21.4851L3.52138 12.9931C1.41705 10.6371 1.49571 7.01913 3.75736 4.75748C6.02157 2.49327 9.64519 2.41699 12.001 4.52865C14.35 2.42012 17.98 2.49012 20.2426 4.75748Z">
                                </path>
                            </svg> -->
            <svg xmlns="http://www.w3.org/2000/svg" width="3em" fill="none" height="3em" viewBox="0 0 24 24">
              <g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                color="currentColor">
                <path
                  d="M7.729 15.286h5m-2.502-2.5h.01m-.008 5h.01M6.5 3.697C9.533 6.782 14.536.124 17.496 2.54C19.199 3.93 18.66 7 16.449 9" />
                <path
                  d="M18.664 6.578c.983.179 1.204.765 1.497 2.392c.265 1.466.339 3.225.339 3.974a1.3 1.3 0 0 1-.338.743c-2.057 2.035-6.137 5.878-8.196 7.787c-.808.681-2.028.696-2.886.07c-1.756-1.491-3.443-3.178-5.097-4.701c-.664-.808-.648-1.956.076-2.717c2.178-2.135 6.12-5.789 8.346-7.807c.223-.18.496-.294.79-.319c.498 0 1.355.063 2.19.109" />
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Impressions -->
  <div class="col-md-3 mb-3">
    <div class="card h-100">
      <div class="card-body d-flex flex-column justify-content-between">
        <h6 class="card-title">IMPRESSIONS</h6>
        <h4>{{eventsData?.eventCounts?.DEAL_IMPRESSIONS_EVENT?.count}}</h4>
        <div class="text-end">
          <div _ngcontent-ng-c3372528096="" class="flex-shrink-0"><svg _ngcontent-ng-c3372528096=""
              xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="3em" height="3em" fill="rgba(135,138,155,1)"
              class="text-muted">
              <path _ngcontent-ng-c3372528096=""
                d="M12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3ZM12.0003 19C16.2359 19 19.8603 16.052 20.7777 12C19.8603 7.94803 16.2359 5 12.0003 5C7.7646 5 4.14022 7.94803 3.22278 12C4.14022 16.052 7.7646 19 12.0003 19ZM12.0003 16.5C9.51498 16.5 7.50026 14.4853 7.50026 12C7.50026 9.51472 9.51498 7.5 12.0003 7.5C14.4855 7.5 16.5003 9.51472 16.5003 12C16.5003 14.4853 14.4855 16.5 12.0003 16.5ZM12.0003 14.5C13.381 14.5 14.5003 13.3807 14.5003 12C14.5003 10.6193 13.381 9.5 12.0003 9.5C10.6196 9.5 9.50026 10.6193 9.50026 12C9.50026 13.3807 10.6196 14.5 12.0003 14.5Z">
              </path>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Reach -->
  <div class="col-md-3 mb-3">
    <div class="card h-100">
      <div class="card-body d-flex flex-column justify-content-between">
        <h6 class="card-title">REACH</h6>
        <h4>{{eventsData?.eventCounts?.DEAL_IMPRESSIONS_UNIQUE_EVENT?.count}}</h4>
        <div class="text-end">
          <div _ngcontent-ng-c3372528096="" class="flex-shrink-0"><svg _ngcontent-ng-c3372528096=""
              xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="3em" height="3em" fill="rgba(135,138,155,1)"
              class="text-muted">
              <path _ngcontent-ng-c3372528096=""
                d="M5 3V19H21V21H3V3H5ZM20.2929 6.29289L21.7071 7.70711L16 13.4142L13 10.415L8.70711 14.7071L7.29289 13.2929L13 7.58579L16 10.585L20.2929 6.29289Z">
              </path>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Clicks -->
  <div class="col-md-3 mb-3">
    <div class="card h-100">
      <div class="card-body d-flex flex-column justify-content-between">
        <h6 class="card-title">CLICKS</h6>
        <h4>{{eventsData?.eventCounts?.DEAL_CLICK_EVENT?.count}}</h4>
        <div class="text-end">
          <div _ngcontent-ng-c3372528096="" class="flex-shrink-0"><svg _ngcontent-ng-c3372528096=""
              xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="3em" height="3em" fill="rgba(135,138,155,1)"
              class="text-muted">
              <path _ngcontent-ng-c3372528096=""
                d="M11.1411 4C9.5587 4 8.75361 4.16876 8.01266 4.56502C7.38342 4.90155 6.90155 5.38342 6.56502 6.01266C6.16876 6.75361 6 7.5587 6 9.14111V14.8589C6 16.4413 6.16876 17.2464 6.56502 17.9873C6.90155 18.6166 7.38342 19.0985 8.01266 19.435C8.75361 19.8312 9.5587 20 11.1411 20H12.8589C14.4413 20 15.2464 19.8312 15.9873 19.435C16.6166 19.0985 17.0985 18.6166 17.435 17.9873C17.8312 17.2464 18 16.4413 18 14.8589V9.14111C18 7.5587 17.8312 6.75361 17.435 6.01266C17.0985 5.38342 16.6166 4.90155 15.9873 4.56502C15.2464 4.16876 14.4413 4 12.8589 4H11.1411ZM11.1411 2H12.8589C14.8728 2 15.9528 2.27848 16.9305 2.8014C17.9083 3.32432 18.6757 4.09169 19.1986 5.06946C19.7215 6.04724 20 7.12721 20 9.14111V14.8589C20 16.8728 19.7215 17.9528 19.1986 18.9305C18.6757 19.9083 17.9083 20.6757 16.9305 21.1986C15.9528 21.7215 14.8728 22 12.8589 22H11.1411C9.12721 22 8.04724 21.7215 7.06946 21.1986C6.09169 20.6757 5.32432 19.9083 4.8014 18.9305C4.27848 17.9528 4 16.8728 4 14.8589V9.14111C4 7.12721 4.27848 6.04724 4.8014 5.06946C5.32432 4.09169 6.09169 3.32432 7.06946 2.8014C8.04724 2.27848 9.12721 2 11.1411 2ZM11 6H13V11H11V6Z">
              </path>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Coupon Code View -->
  <div class="col-md-3 mb-3">
    <div class="card h-100">
      <div class="card-body d-flex flex-column justify-content-between">
        <h6 class="card-title">COUPON CODE VIEW</h6>
        <h4>{{eventsData?.eventCounts?.DEAL_COUPON_CODE_VIEW_EVENT?.count}}</h4>
        <div class="text-end">
          <div _ngcontent-ng-c3372528096="" class="flex-shrink-0"><svg _ngcontent-ng-c3372528096=""
              xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="3em" height="3em"
              fill="rgba(135,138,155,1)">
              <path _ngcontent-ng-c3372528096=""
                d="M2.00488 9.49979V3.99979C2.00488 3.4475 2.4526 2.99979 3.00488 2.99979H21.0049C21.5572 2.99979 22.0049 3.4475 22.0049 3.99979V9.49979C20.6242 9.49979 19.5049 10.6191 19.5049 11.9998C19.5049 13.3805 20.6242 14.4998 22.0049 14.4998V19.9998C22.0049 20.5521 21.5572 20.9998 21.0049 20.9998H3.00488C2.4526 20.9998 2.00488 20.5521 2.00488 19.9998V14.4998C3.38559 14.4998 4.50488 13.3805 4.50488 11.9998C4.50488 10.6191 3.38559 9.49979 2.00488 9.49979ZM4.00488 7.96755C5.4866 8.7039 6.50488 10.2329 6.50488 11.9998C6.50488 13.7666 5.4866 15.2957 4.00488 16.032V18.9998H20.0049V16.032C18.5232 15.2957 17.5049 13.7666 17.5049 11.9998C17.5049 10.2329 18.5232 8.7039 20.0049 7.96755V4.99979H4.00488V7.96755ZM9.00488 8.99979H15.0049V10.9998H9.00488V8.99979ZM9.00488 12.9998H15.0049V14.9998H9.00488V12.9998Z">
              </path>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Favorite -->
  <div class="col-md-3 mb-3">
    <div class="card h-100">
      <div class="card-body d-flex flex-column justify-content-between">
        <h6 class="card-title">FAVORITE</h6>
        <h4>{{eventsData?.eventCounts?.DEAL_FAVOURITE_EVENT?.count}}</h4>
        <div class="text-end">
          <div _ngcontent-ng-c3372528096="" class="flex-shrink-0"><svg _ngcontent-ng-c3372528096=""
              xmlns="http://www.w3.org/2000/svg" width="3em" height="3em" viewBox="0 0 24 24"
              fill="rgba(135,138,155,1)">
              <path _ngcontent-ng-c3372528096=""
                d="M5.911 6.964c1.524-1.6 3.697-1.55 5.189-.253a1.375 1.375 0 0 0 1.796 0c1.491-1.298 3.666-1.346 5.188.253c.887 1.133 1.196 2.178 1.164 3.137c-.033.982-.426 1.958-1.086 2.922c-1.335 1.953-3.624 3.67-5.557 5.033a1.05 1.05 0 0 1-1.214 0c-1.919-1.356-4.208-3.074-5.547-5.028c-.661-.966-1.057-1.944-1.091-2.926c-.035-.96.272-2.006 1.158-3.138m6.087-1.458C9.933 3.782 6.88 3.74 4.796 5.96l-.022.024l-.02.025c-1.09 1.38-1.55 2.775-1.5 4.146c.048 1.355.59 2.606 1.353 3.72c1.511 2.208 4.02 4.065 5.918 5.406c.885.625 2.06.625 2.945.001c1.911-1.348 4.422-3.206 5.93-5.412c.762-1.114 1.301-2.364 1.347-3.718c.046-1.37-.416-2.763-1.506-4.143l-.02-.025l-.022-.024c-2.083-2.22-5.138-2.178-7.201-.454">
              </path>
            </svg></div>
        </div>
      </div>
    </div>
  </div>

  <!-- CTR -->
  <div class="col-md-3 mb-3">
    <div class="card h-100">
      <div class="card-body d-flex flex-column justify-content-between">
        <h6 class="card-title">CTR</h6>
        <h4>{{eventsData?.ctr}}</h4>
        <div class="text-end">
          <div _ngcontent-ng-c3372528096="" class="flex-shrink-0"><svg _ngcontent-ng-c3372528096=""
              xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="3em" height="3em"
              fill="rgba(135,138,155,1)">
              <path _ngcontent-ng-c3372528096=""
                d="M10.0544 2.0941C11.1756 1.13856 12.8248 1.13855 13.9461 2.09411L15.2941 3.24286C15.4542 3.37935 15.6533 3.46182 15.8631 3.47856L17.6286 3.61945C19.0971 3.73663 20.2633 4.9028 20.3805 6.37131L20.5214 8.13679C20.5381 8.34654 20.6205 8.54568 20.757 8.70585L21.9058 10.0539C22.8614 11.1751 22.8614 12.8243 21.9058 13.9456L20.757 15.2935C20.6206 15.4537 20.538 15.6529 20.5213 15.8627L20.3805 17.6281C20.2633 19.0967 19.0971 20.2628 17.6286 20.3799L15.8631 20.5208C15.6533 20.5376 15.4542 20.6201 15.2941 20.7566L13.9461 21.9053C12.8248 22.8609 11.1756 22.8608 10.0543 21.9053L8.70631 20.7566C8.54615 20.6201 8.34705 20.5376 8.1373 20.5209L6.37184 20.3799C4.9033 20.2627 3.73716 19.0966 3.61997 17.6281L3.47906 15.8627C3.46232 15.6529 3.37983 15.4538 3.24336 15.2936L2.0946 13.9455C1.13905 12.8243 1.13904 11.1752 2.09458 10.0539L3.24334 8.70589C3.37983 8.54573 3.46234 8.34654 3.47907 8.13678L3.61996 6.3713C3.73714 4.90278 4.90327 3.73665 6.3718 3.61946L8.13729 3.47857C8.34705 3.46183 8.54619 3.37935 8.70636 3.24286L10.0544 2.0941ZM12.6488 3.61632C12.2751 3.29782 11.7253 3.29781 11.3516 3.61632L10.0036 4.76509C9.5231 5.17456 8.92568 5.42201 8.29637 5.47223L6.5309 5.61312C6.04139 5.65219 5.65268 6.04089 5.61362 6.53041L5.47272 8.29593C5.4225 8.92521 5.17505 9.52259 4.76559 10.0031L3.61683 11.3511C3.29832 11.7248 3.29831 12.2746 3.61683 12.6483L4.76559 13.9963C5.17506 14.4768 5.4225 15.0743 5.47275 15.7035L5.61363 17.469C5.65268 17.9585 6.04139 18.3473 6.53092 18.3863L8.29636 18.5272C8.92563 18.5774 9.5231 18.8249 10.0036 19.2344L11.3516 20.3831C11.7254 20.7016 12.2751 20.7016 12.6488 20.3831L13.9969 19.2343C14.4773 18.8249 15.0747 18.5774 15.704 18.5272L17.4695 18.3863C17.959 18.3472 18.3478 17.9585 18.3868 17.469L18.5277 15.7035C18.5779 15.0742 18.8253 14.4768 19.2349 13.9964L20.3836 12.6483C20.7022 12.2746 20.7021 11.7249 20.3836 11.3511L19.2348 10.0031C18.8253 9.52259 18.5779 8.92519 18.5277 8.2959L18.3868 6.53041C18.3478 6.0409 17.959 5.65219 17.4695 5.61312L15.704 5.47224C15.0748 5.42203 14.4773 5.17455 13.9968 4.76508L12.6488 3.61632ZM14.8284 7.75718L16.2426 9.1714L9.17154 16.2425L7.75733 14.8282L14.8284 7.75718ZM10.2322 10.232C9.64641 10.8178 8.69667 10.8178 8.11088 10.232C7.52509 9.6463 7.52509 8.69652 8.11088 8.11073C8.69667 7.52494 9.64641 7.52494 10.2322 8.11073C10.818 8.69652 10.818 9.6463 10.2322 10.232ZM13.7677 15.8889C14.3535 16.4747 15.3032 16.4747 15.889 15.8889C16.4748 15.3031 16.4748 14.3534 15.889 13.7676C15.3032 13.1818 14.3535 13.1818 13.7677 13.7676C13.1819 14.3534 13.1819 15.3031 13.7677 15.8889Z">
              </path>
            </svg></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Money Spend -->
  <div class="col-md-3 mb-3">
    <div class="card h-100">
      <div class="card-body d-flex flex-column justify-content-between">
        <h6 class="card-title">MONEY SPEND</h6>
        <h4>{{eventsData?.moneySpent}}</h4>
        <div class="text-end">
          <div _ngcontent-ng-c3372528096="" class="flex-shrink-0"><svg _ngcontent-ng-c3372528096=""
              xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="3em" height="3em"
              fill="rgba(135,138,155,1)">
              <path _ngcontent-ng-c3372528096=""
                d="M19.3788 15.1057C20.9258 11.4421 19.5373 7.11431 16.0042 5.0745C13.4511 3.60046 10.4232 3.69365 8.03452 5.0556L7.04216 3.31879C10.028 1.61639 13.8128 1.4999 17.0042 3.34245C21.4949 5.93513 23.2139 11.4848 21.1217 16.112L22.4635 16.8867L18.2984 19.1008L18.1334 14.3867L19.3788 15.1057ZM4.62961 8.89968C3.08263 12.5633 4.47116 16.8911 8.00421 18.9309C10.5573 20.4049 13.5851 20.3118 15.9737 18.9499L16.9661 20.6867C13.9803 22.389 10.1956 22.5055 7.00421 20.663C2.51357 18.0703 0.794565 12.5206 2.88672 7.89342L1.54492 7.11873L5.70999 4.90463L5.87505 9.61873L4.62961 8.89968ZM8.50421 14.0027H14.0042C14.2804 14.0027 14.5042 13.7788 14.5042 13.5027C14.5042 13.2266 14.2804 13.0027 14.0042 13.0027H10.0042C8.6235 13.0027 7.50421 11.8834 7.50421 10.5027C7.50421 9.122 8.6235 8.00271 10.0042 8.00271H11.0042V7.00271H13.0042V8.00271H15.5042V10.0027H10.0042C9.72807 10.0027 9.50421 10.2266 9.50421 10.5027C9.50421 10.7788 9.72807 11.0027 10.0042 11.0027H14.0042C15.3849 11.0027 16.5042 12.122 16.5042 13.5027C16.5042 14.8834 15.3849 16.0027 14.0042 16.0027H13.0042V17.0027H11.0042V16.0027H8.50421V14.0027Z">
              </path>
            </svg></div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="filter-container pt-2">
  <label for="statusFilter">Status:</label>
  <select style="width: 25%;" class="form-control" id="statusFilter" [ngModelOptions]="{standalone: true}"
    [(ngModel)]="selectedStatus">
    <option value="A,C,E">All</option>
    <!-- <option value="P">Pending</option>
    <option value="D">Draft</option> -->
    <option value="C">Completed</option>
    <option value="A">Active</option>
    <option value="E">Expired</option>
  </select>

  <label style="width: 10%;" for="dateFilter">{{reportPlaceHolders['LBL_DATE_FROM']}}:</label>
  <input class="form-control" style="width: 25%;" type="date" id="dateFilter" [ngModelOptions]="{standalone: true}"
    [(ngModel)]="dateFrom">

  <label style="width: 7%;" for="dateToFilter">{{reportPlaceHolders['LBL_DATE_TO']}}:</label>
  <input class="form-control" style="width: 25%;" type="date" id="dateToFilter" [ngModelOptions]="{standalone: true}"
    [(ngModel)]="dateTo">

  <button style="width: 14%;" (click)="customOkClick()">{{reportPlaceHolders['LBL_APPLY_FILTERS']}}</button>
  <button (click)="resetFilters()">{{reportPlaceHolders['LBL_RESET']}}</button>
</div>



<div class="table-container">
  <table class="styled-table">
    <thead>
      <tr>
        <th>UUID</th>
        <th>Image</th>
        <th>{{reportPlaceHolders['TBL_NAME']}}</th>
        <th>{{reportPlaceHolders['TBL_STATUS']}}</th>
        <th>{{reportPlaceHolders['TBL_BUDGET']}}</th>
        <th>{{reportPlaceHolders['TBL_TOTAL_SPENT']}}</th>
        <th>{{reportPlaceHolders['TBL_CHARGED']}}</th>
        <th>{{reportPlaceHolders['TBL_CREATED_DATE']}}</th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let deal of paginatedDeals">
        <td>{{ deal.uuid }}</td>
        <td><img [src]="getFullImageUrl(deal.product_image)" alt="Image preview" class="product-img" /></td>
        <td style="width: 25%;">{{ deal.product_name }}</td>
        <td>
          <mat-chip [ngClass]="getStatusClass(deal.status)">
            {{ getStatusLabel(deal.status) }}
          </mat-chip>
        </td>
        <td>{{ deal.budget }}</td>
        <td>{{ deal.total_spent }}</td>
        <td>{{ deal.spentAlreadyCharged }}</td>
        <td>{{ deal.created_date }}</td>
        <td>
          <button (click)="viewDetails(deal)">{{reportPlaceHolders['LBL_lower_Web_View']}} </button>
        </td>
      </tr>
    </tbody>
  </table>
  <div class="pagination">
    <!-- <button (click)="previousPage()" [disabled]="currentPage === 1">Previous</button>
    <span>Page {{ currentPage }} of {{ totalPages }}</span>
    <button (click)="nextPage()" [disabled]="currentPage === totalPages">Next</button> -->
    <div style="display: flex; align-items: center; justify-content: center; gap: 16px;">
      <button (click)="previousPage()" [disabled]="currentPage === 1" style="font-size: 20px;padding: 0px 5px;">
        &#8592;
      </button>

      <div style="padding: 8px 16px; background-color: #ffffff; border-radius: 8px;">
        Page {{ currentPage }} of {{ totalPages }}
      </div>

      <button (click)="nextPage()" [disabled]="currentPage === totalPages" style="font-size: 20px;padding: 0px 5px;">
        &#8594;
      </button>
    </div>
  </div>
</div>